import { UserRole } from '~shared/types'

export const TeamMemberRoles: Partial<
  Record<
    UserRole,
    {
      name: string
      displayName: string
      css: string
      description?: string
    }
  >
> = {
  [UserRole.TEAM_ADMIN]: {
    name: 'admin',
    displayName: 'Team Admin',
    css: 'text-red-600',
    description:
      'Full access to add/remove members, billing, events and rundowns.',
  },
  [UserRole.TEAM_SHOWCALLER]: {
    name: 'show_caller',
    displayName: 'Team Show Caller',
    css: 'text-orange-500',
    description: 'Edit and control all team events and rundowns.',
  },
  [UserRole.TEAM_EDITOR]: {
    name: 'editor',
    displayName: 'Team Editor',
    css: 'text-red-400',
    description: 'Edit-only access to all team events and rundowns.',
  },
  [UserRole.TEAM_VIEWER]: {
    name: 'team-viewer',
    displayName: 'Team Viewer',
    css: 'text-lime-500',
    description: 'View-only access to all team events and rundowns.',
  },
  [UserRole.EVENT_SHOWCALLER]: {
    name: 'event-show-caller',
    displayName: 'Event Show Caller',
    css: 'text-amber-500',
    description: 'Edit and control events assigned to them.',
  },
  [UserRole.EVENT_EDITOR]: {
    name: 'event-editor',
    displayName: 'Event Editor',
    css: 'text-yellow-500',
    description: 'Edit-only access to events assigned to them.',
  },
  [UserRole.EVENT_VIEWER]: {
    name: 'event-viewer',
    displayName: 'Event Viewer',
    css: 'text-green-400',
    description: 'View-only access to events assigned to them.',
  },
}
